<template>
  <div class="savedSearchForm">
    <neb-form-control label="Name"
      width="300px"
    >
      <neb-input v-model="formData.name"></neb-input>
    </neb-form-control>

    <neb-form-control align="end">
      <neb-button type="secondary"
        @click="$emit('cancel')"
      >Cancel</neb-button>
      <neb-button @click="onSubmit">Save</neb-button>
    </neb-form-control>
  </div>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  name: 'SavedSearchForm',

  props: {
    name: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    formData: {
      name: ''
    }
  }),

  methods: {
    onSubmit () {
      this.$emit('submit', this.formData)
    }
  },

  mounted() {
    if (!isEmpty(this.name)) {
      this.formData.name = this.name
    }
  }
}
</script>
